import { render, staticRenderFns } from "./quesSuccess1.vue?vue&type=template&id=48b5cc34"
import script from "./quesSuccess1.vue?vue&type=script&lang=js"
export * from "./quesSuccess1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports